// Module
var code = "<script src=\"https://s.wildapricot.net/Scripts/v3.1.1/jquery.js\"></script> <script src=\"https://s.wildapricot.net/Scripts/v100/Combined.js\"></script> ";
// Exports
export default code;